export function queryStringToObject(query) {
  let match
  const pl = /\+/g
  const search = /([^&=]+)=([^&]*)/g
  const decode = s => decodeURIComponent(decodeURIComponent(s.replace(pl, " ")))
  const obj = {}
  match = search.exec(query)
  while (match) {
    obj[decode(match[1])] = decode(match[2])
    match = search.exec(query)
  }
  return obj
}
